export enum ContactVisibility {
  VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS = 'VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS',
  VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS_FROM_REGION = 'VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS_FROM_REGION',
  VISIBLE_TO_WORLD_BUREAU_STAFF = 'VISIBLE_TO_WORLD_BUREAU_STAFF'
}
